module.exports = __webpack_public_path__ + "static/img/logo@2x.724ceda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bamei/logo@2x.png
// module id = ZR9O
// module chunks = 71